import React, { useContext, useState } from "react";
import { Button } from "antd";
import AssignPOIsDrawer from "./AssignPOIsDrawer";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import GeofencesMultiInput from "../../Helpers/MultiInput/GeofencesMultiInput";
import NotificationsMultiInput from "../../Helpers/MultiInput/NotificationsMultiInput";
import DriversMultiInput from "../../Helpers/MultiInput/DriversMultiInput";

import {
  useAddPermissionMutation,
  useDeletePermissionMutation,
} from "../../../Redux/service/Permissions/Permissions";
import { toast } from "react-toastify";
import trans from "../../../utils";
import VehiclesMultiInput from "../../Helpers/MultiInput/VehiclesMultiInput";
import UsersMultiInput from "../../Helpers/MultiInput/UsersMultiInput";
import GroupsMultiInput from "../../Helpers/MultiInput/GroupsMultiInput";
import { popupcontext } from "../../../context/Popupscontext";
import FieldStaffMultiInput from "../../Helpers/MultiInput/FieldStaffMultiInput";
import {
  useAddFieldStaffPermissionMutation,
  useDeleteFieldStaffPermissionMutation,
} from "../../../Redux/service/Permissions/FieldStaffPermissions";
import {
  useAddCustomerPermissionMutation,
  useDeleteCustomerPermissionMutation,
} from "../../../Redux/service/Permissions/CustomerPermissions";
import CustomersMultiInput from "../../Helpers/MultiInput/CustomersMultiInput";
import POIsMultiInput from "../../Helpers/MultiInput/POIsMultiInput";
import {
  useAddPOIsPermissionMutation,
  useDeletePOIsPermissionMutation,
} from "../../../Redux/service/Permissions/POIsPermissions";
import { useGetSpecificUserQuery } from "../../../Redux/service/Users/Users";
import FormsMultiInput from "../../Helpers/MultiInput/FormsMultiInput";
import {
  useAddFormPermissionMutation,
  useDeleteFormPermissionMutation,
} from "../../../Redux/service/Permissions/FormsPermissions";
//import { useSelector } from "react-redux";

export default function UsersConnectionPopup({
  userId,
  name,
  setIsLinking,
  role,
}) {
  const { setReloadData } = useContext(popupcontext);
  const [addPermission] = useAddPermissionMutation();
  const [deletePermission] = useDeletePermissionMutation();
  const [addFieldStaffPermission] = useAddFieldStaffPermissionMutation();
  const [deleteFieldStaffPermission] = useDeleteFieldStaffPermissionMutation();
  const [addCustomerPermission] = useAddCustomerPermissionMutation();
  const [deleteCustomerPermission] = useDeleteCustomerPermissionMutation();
  const [addPOIPermission] = useAddPOIsPermissionMutation();
  const [deletePOIPermission] = useDeletePOIsPermissionMutation();
  const [addFormPermission] = useAddFormPermissionMutation();
  const [deleteFormPermission] = useDeleteFormPermissionMutation();
  // Bulk POI assignment drawer; bumping the key remounts POIsMultiInput so it
  // refetches the assigned list after a bulk save
  const [showPoiDrawer, setShowPoiDrawer] = useState(false);
  const [poiInputKey, setPoiInputKey] = useState(0);
  //const inf = useSelector((state) => state.users.user);
  // Hide Users / Field Staff / Customers connections for read-only target users
  const { data: targetUser } = useGetSpecificUserQuery(userId, {
    skip: !userId,
  });
  const isReadonly = targetUser?.readonly === true;
  const isDeviceReadonly = targetUser?.deviceReadonly === true;
  const failAddPermission = (name, type) => {
    if (name === "Field Staff" || name === "Customer" || name === "POI") {
      return `${trans("Failed to link")} ${trans(name)} ${trans("to user")}`;
    } else {
      return `${trans("Failed to link")} ${trans(type)} ${trans("to user")}`;
    }
  };
  const failDeletePermission = (name, type, error) => {
    if (name === "Field Staff" || name === "Customer" || name === "POI") {
      return `${trans(error?.data?.message)}`;
    } else {
      return `${trans("Failed to unlink")} ${trans(type)} ${trans("to user")}`;
    }
  };
  const handleLink = async (id, type, name) => {
    try {
      let apiCall;
      let successMessage;

      if (name === "Field Staff") {
        apiCall = addFieldStaffPermission({
          userId,
          [`${type}Id`]: id,
        });
        successMessage = trans("Field Staff is linked to user successfully");
      } else if (name === "Customer") {
        apiCall = addCustomerPermission({
          userId,
          [`${type}Id`]: id,
        });
        successMessage = trans("Customer is linked to user successfully");
      } else if (name === "POIs") {
        apiCall = addPOIPermission({
          userId,
          [`${type}`]: id,
        });
        successMessage = trans("POI is linked to user successfully");
      } else if (name === "Forms") {
        apiCall = addFormPermission({
          userId,
          formId: id,
        });
        successMessage = trans("Form is linked to user successfully");
      } else {
        apiCall = addPermission({
          userId,
          [`${type}Id`]: id,
        });

        const typeSuccessMessages = {
          geofence: trans("Geofence is linked to user successfully"),
          notification: trans("Notification is linked to user successfully"),
          driver: trans("Driver is linked to user successfully"),
          device: trans("Vehicle is linked to user successfully"),
          managedUser: trans("User is linked to user successfully"),
          group: trans("Group is linked to user successfully"),
        };

        successMessage =
          typeSuccessMessages[type] || trans("Linked successfully");
      }

      await apiCall.unwrap();

      setReloadData(true);

      toast.success(successMessage, {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
    } catch (error) {
      console.error(error);

      toast.error(failAddPermission(name, type), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
    }
  };

  const handleUnLink = async (id, type, name) => {
    try {
      let apiCall;
      let successMessage;

      if (name === "Field Staff") {
        apiCall = deleteFieldStaffPermission({
          userId,
          [`${type}Id`]: id,
        });
        successMessage = trans(
          "Field Staff is unlinked from user successfully",
        );
      } else if (name === "Customer") {
        apiCall = deleteCustomerPermission({
          userId,
          [`${type}Id`]: id,
        });
        successMessage = trans("Customer is unlinked from user successfully");
      } else if (name === "POIs") {
        apiCall = deletePOIPermission({
          userId,
          [`${type}`]: id,
        });
        successMessage = trans("POI is unlinked from user successfully");
      } else if (name === "Forms") {
        apiCall = deleteFormPermission({
          userId,
          formId: id,
        });
        successMessage = trans("Form is unlinked from user successfully");
      } else {
        apiCall = deletePermission({
          userId,
          [`${type}Id`]: id,
        });

        const typeSuccessMessages = {
          geofence: trans("Geofence is unlinked from user successfully"),
          notification: trans(
            "Notification is unlinked from user successfully",
          ),
          driver: trans("Driver is unlinked from user successfully"),
          device: trans("Vehicle is unlinked from user successfully"),
          managedUser: trans("User is unlinked from user successfully"),
          group: trans("Group is unlinked from user successfully"),
        };

        successMessage =
          typeSuccessMessages[type] || trans("Unlinked from user successfully");
      }

      await apiCall.unwrap();

      setReloadData(true);

      toast.success(successMessage, {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
    } catch (error) {
      console.error(error);
      toast.error(failDeletePermission(name, type, error), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
    }
  };

  return (
    <Popup show={!!userId} size="xl" style={"popup-bodyscroll"}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={name}
            subtitle={trans("Connect or link this user to other modules.")}
          />
        </Modal.Title>
        <Close
          // eslint-disable-next-line react/style-prop-object
          style="close-32 close"
          close={() => {
            setIsLinking(false);
          }}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <VehiclesMultiInput
          label="Vehicles"
          styling="mb-3"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          userId={userId}
          type="users"
        />
        {!isReadonly && !isDeviceReadonly && role !== "Readonly" && (
          <UsersMultiInput
            label="Users"
            styling="mb-3"
            handleLink={handleLink}
            handleUnLink={handleUnLink}
            userId={userId}
            type="users"
          />
        )}
        <GeofencesMultiInput
          label="geofences"
          styling="mb-3"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          userId={userId}
          type="users"
        />
        <GroupsMultiInput
          label="Groups"
          styling="mb-3"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          userId={userId}
          type="users"
        />
        <DriversMultiInput
          label="drivers"
          styling="mb-3"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          userId={userId}
          type="users"
        />
        <NotificationsMultiInput
          label="notifications"
          styling="mb-3"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          userId={userId}
          type="users"
        />
        {!isReadonly && (
          <FieldStaffMultiInput
            label="Field Staff"
            styling="mb-3"
            handleLink={handleLink}
            handleUnLink={handleUnLink}
            userId={userId}
            type="users"
          />
        )}
        {!isReadonly && (
          <CustomersMultiInput
            label="Customers"
            styling="mb-3"
            handleLink={handleLink}
            handleUnLink={handleUnLink}
            userId={userId}
            type="users"
          />
        )}
        <POIsMultiInput
          key={poiInputKey}
          label="POIs"
          styling="mb-1"
          handleLink={handleLink}
          handleUnLink={handleUnLink}
          userId={userId}
          type="users"
        />
        <div className="d-flex justify-content-end mb-3">
          <Button type="link" size="small" onClick={() => setShowPoiDrawer(true)}>
            {trans("Manage all POIs (bulk)")}
          </Button>
        </div>
        <AssignPOIsDrawer
          userId={userId}
          userName={targetUser?.name}
          open={showPoiDrawer}
          onClose={() => setShowPoiDrawer(false)}
          onSaved={() => setPoiInputKey((k) => k + 1)}
        />
        {!isReadonly && (
          <FormsMultiInput
            label="Forms"
            styling="mb-3"
            handleLink={handleLink}
            handleUnLink={handleUnLink}
            userId={userId}
            type="users"
          />
        )}
      </Modal.Body>
    </Popup>
  );
}
